/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AutoCompleteAddressRequest} from '@cash-web/protos/squareup/cash/local/client/v1/auto_complete.pb'
import {AutoCompleteAddressResponse} from '@cash-web/protos/squareup/cash/local/client/v1/auto_complete.pb'


export const autoCompleteAddress = (request:AutoCompleteAddressRequest, options?: CashRequestOptions) => post<AutoCompleteAddressRequest, AutoCompleteAddressResponse>("/cash-app/local/auto-complete-address", request, {...options, rejectOnError: true })